import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import { GMapsMultipleMarkerComponent } from '@/components/reusable/GMapsComponent/GMapsMultipleMarkerComponent';
import { GMapsComponent } from '@/components/reusable/GMapsComponent/GMapsComponent';

const MapSection = props => {
  const {
    spaceData,
  } = props;

  return (
    <FlexContainer className="width100 height-260px borderrad14 bgGray025 overflow-hidden ">
        <GMapsComponent
              spaceData={spaceData}
              customHeight={'260px'}
            /> 
    </FlexContainer>
  );
};

export default MapSection;
